import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../_App/Redux/hooks";
import { findVisiteTechniques } from "../_App/Redux/Slices/visiteTech/visiteTechSlice";
import VisiteTechniqueList from "../Components/VisiteTech/VisiteTechList";
import VisiteTechniqueForm from "../Components/VisiteTech/VisiteTechForm";
import { findVehicules } from "../_App/Redux/Slices/vehicules/vehiculesSlice";
import {
  currentSousSociete,
  OnlineUser,
} from "../_App/Redux/Slices/auth/authSlice";
import { findFiles } from "../_App/Redux/Slices/files/filesSlice";

const VisiteTechnique = () => {
  const dispatch = useAppDispatch();
  const [showModal, setShowModal] = useState(false);
  const [selectedVisiteTechnique, setSelectedVisiteTechnique] =
    useState(undefined);
  const [load, setLoad] = useState(false);
  const currentSousSte = useAppSelector(currentSousSociete);
  const [searchTerm, setSearchTerm] = useState(""); // Add state for search term

  useEffect(() => {
    if (currentSousSte) {
      dispatch(findVisiteTechniques(currentSousSte));
      dispatch(findVehicules(currentSousSte));
      dispatch(findFiles(null));
    }
    // If you need to dispatch any other actions related to camions or other entities, do it here.
  }, [dispatch, load, currentSousSte]);

  return (
    <div>
      <nav className="navbar search-bar">
        <a href="#" className="sidebar-toggler">
          <i data-feather="menu" />
        </a>
        <div className="navbar-content">
          <form className="search-form">
            <div className="input-group">
              <div className="input-group-prepend">
                <div className="input-group-text">
                  <i data-feather="search" />
                </div>
              </div>
              <input
                type="text"
                className="form-control"
                id="navbarForm"
                placeholder="Chercher ..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
              />
            </div>
          </form>
        </div>
      </nav>
      <nav className="page-breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a href="#">Visite Technique</a>
          </li>
        </ol>
      </nav>
      <div className="row content-card">
        <div className="col-12">
          <div className="card">
            <div className="card-header">
              <i className="mdi mdi-tune-vertical text-primary " /> Liste des
              Visites Techniques{" "}
              <button
                className="btn btn-primary float-right"
                onClick={() => setShowModal(true)}
              >
                +
              </button>
            </div>
            <VisiteTechniqueList
              searchTerm={searchTerm}
              selectedVisiteTechnique={selectedVisiteTechnique}
              setSelectedVisiteTechnique={setSelectedVisiteTechnique}
              setShowModal={setShowModal}
              load={load}
              setLoad={setLoad}
            />
            <VisiteTechniqueForm
              showModal={showModal}
              setShowModal={setShowModal}
              selectedVisiteTechnique={selectedVisiteTechnique}
              setSelectedVisiteTechnique={setSelectedVisiteTechnique}
              load={load}
              setLoad={setLoad}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisiteTechnique;
